import { useQuery } from "@tanstack/react-query";
import { getPostById } from "../../redux/post/postAction";
import { getSingleReelsById } from "../../redux/reels/reelsAction";


export function usePost(postId) {
    return useQuery({
        queryKey: ["post", postId],
        queryFn: () => getPostById(postId),
        enabled: !!postId
    });
}


export function useReelPost(postId, disable) {
    return useQuery({
        queryKey: ["reels", postId],
        queryFn: () => getSingleReelsById(postId),
        enabled: !!postId && !disable
    });
}